import {PIXI} from '@colonist/pixi'
import {GameColor} from '../../GameColor'
import {ArrayUtils, RandomUtils} from '@colonist/utils'

const SKEW_CHANGE = 0.05
const SIZE = [10, 20]

const COLORS = [
    GameColor.getColorHexValue(GameColor.Color.PlayerBlueBgDark),
    GameColor.getColorHexValue(GameColor.Color.PlayerRedBgDark),
    GameColor.getColorHexValue(GameColor.Color.PlayerOrangeBgDark),
    GameColor.getColorHexValue(GameColor.Color.PlayerGreenBgDark),
]

export interface UIGameAchievementConfettiItemOptions {
    x: number
    y: number
    speed: number[]
    angle: number[]
    slow: number
    gravity: number[]
    count: number
    wait?: number
}

export class UIGameAchievementConfettiItem extends PIXI.Sprite {
    skewX: number
    skewY: number
    vx: number
    vy: number
    slow: number
    gravity: number
    wait: number

    constructor(options?: UIGameAchievementConfettiItemOptions) {
        super(PIXI.Texture.WHITE)
        if(options) this.reset(options)
        this.anchor.set(0.5)
    }

    reset(options: UIGameAchievementConfettiItemOptions) {
        this.position.set(options.x, options.y)
        this.tint = ArrayUtils.randomElementFromArray(COLORS) as number
        const angle = RandomUtils.randomNumberBetweenFloat(options.angle[0], options.angle[1])
        const speed = RandomUtils.randomNumberBetweenFloat(options.speed[0], options.speed[1])
        this.vx = Math.cos(angle) * speed
        this.vy = Math.sin(angle) * speed
        this.gravity = RandomUtils.randomNumberBetweenFloat(options.gravity[0], options.gravity[1])
        this.height = RandomUtils.randomNumberBetweenFloat(SIZE[0], SIZE[1])
        this.width = this.height / 2
        this.rotation = RandomUtils.randomAngle()
        this.skew.set(0, 0)
        this.skewX = RandomUtils.randomNegativePositive(SKEW_CHANGE)
        this.skewY = RandomUtils.randomNegativePositive(SKEW_CHANGE)
        this.slow = options.slow
        this.wait = typeof options.wait === 'undefined' ? 0 : options.wait
    }

    update(deltaTime: number, elapsedMS: number): boolean {
        if(this.wait > 0) {
            this.wait -= elapsedMS
            if(this.wait <= 0) {
                this.wait = 0
            } else {
                return false
            }
        }
        this.skew.x += this.skewX
        this.skew.y += this.skewY
        this.x += this.vx * deltaTime
        this.y += this.vy * deltaTime
        if(this.vx < 0) {
            this.vx += this.slow * deltaTime
            this.vx = this.vx > 0 ? 0 : this.vx
        } else if(this.vx > 0) {
            this.vx -= this.slow * deltaTime
            this.vx = this.vx < 0 ? 0 : this.vx
        }
        if(this.vy < this.gravity) {
            this.vy += this.slow * deltaTime
            this.vy = this.vy > this.gravity ? this.gravity : this.vy
        } else if(this.vy > this.gravity) {
            this.vy -= this.slow * deltaTime
            this.vy = this.vy < this.gravity ? this.gravity : this.vy
        }

        if(this.y - this.height > window.innerHeight) {
            return true
        } else {
            return false
        }
    }
}
